import React from 'react';
import {
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	CustomInput,
	Form,
	Row,
	Col,
	Label,

} from 'reactstrap';
import { Button,Input,} from 'antd';
import {getData} from '../services/index';
import { message  } from 'antd';

import logo from '../assets/images/icon/logo.png';

class Login2 extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOpen: false,
			light_logo:true,
			dark_logo:false,
			open_login_modal:false,
			open_register_modal:false,
			open_otp_modal:false,
			open_forgot_modal:false,
			open_reset_modal:false,
			open_mobile_modal:false,
			provider_id:0,
			mobile : '',
			reset_mobile : '',
			l_email : '',
			l_password : '',
		};
		this.doLogin = this.doLogin.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
	}

	doLogin = (event) => {
		var app = {
			email : this.state.l_email,
			password : this.state.l_password
		}
		this.setState({ loading: true });
		getData('auth/school_login',app).then((result) => {
			if(result.status==400){
				document.getElementById('login_alert').innerHTML = result.message;
				this.setState({ loading: false });
			}
			if(result.status==200){
				let responseJson = result;
				if(responseJson.data){
					localStorage.setItem('schoolData',JSON.stringify(responseJson));

					var erp_id = result['data'][0]['erp_id'];
					var erp_type = erp_id.split('_');
					localStorage.setItem("erp_id",erp_id);
					localStorage.setItem("erp_type",erp_type[0]);
					var name = result['data'][0]['user_name'];
					var phone = result['data'][0]['phone'];
					var email = result['data'][0]['email'];
					var user_id = result['data'][0]['user_id'];
					var school_id = result['data'][0]['school_id'];
					var short_name = result['data'][0]['short_name'];
					var type = result['data'][0]['type'];
					var permission = result['data'][0]['permission'];
					var profile_pic = result['data'][0]['profile_pic'];
					this.setState({
						'name': name,
						'phone': phone,
						'email': email,
						'user_id': user_id,
						'school_id': school_id,
						'short_name': short_name,
						'type': type,
						'permission': permission,
						'profile_pic': profile_pic,
					});
					message.config({ top: 50});
				    message.success('Successfully Logged In.');
					setTimeout(() => {
						window.location.href = '/';
					}, 500);
					this.setState({ loading: true });
				}
			}
		})
		.catch(error => {
			message.config({ top: 50});
			message.error('Invalid Username or Password');
			this.setState({ loading: false });
		});
		event.preventDefault();
	}

	onInputChange(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(localStorage.getItem('schoolData')) {
			window.location.href = '/';
		}

	}

	render() {
	return (
		<div className="app-content content login-page">
			<div className="content-overlay"></div>
			<div className="container">
				<div className="content-wrapperz">
					<div className="content-body">
						<div className="auth-wrapper auth-basic px-2">
							<div className="content-text">
								<h3>
									Streamline Your <span className="secondry-color">Sales</span>, Supercharge Your <span className="secondry-color">Growth.</span>
								</h3>
								<div className="row">
									<div className="col-md-4">
										<i className="ri-user-follow-line"></i> Insights
									</div>
									<div className="col-md-4">
										<i className="ri-service-fill"></i> Easy To Use
									</div>
									<div className="col-md-4">
										<i className="ri-dashboard-line"></i> Powerful Dashboard
									</div>
								</div>
							</div>
							<div className="auth-inner my-2">
								<div className="card mb-0 main-bg">
									<div className="card-body1">
										<a href="#" className="brand-logo">
											<img src={`${process.env.PUBLIC_URL}/assets/img/logo.png`} height="70" alt="logo" />
										</a>
										<h4 className="card-title text-center mb-1 mt-1" style={{ fontSize: "22px" }}>Login</h4>
										<p className="card-text text-center">Please sign-in to your account</p>
										<form className="mt-2 login-form" onSubmit={this.doLogin}>
											<div className="mb-1">
												<label className="form-label" htmlFor="email-id-icon">Username</label>
												<div className="input-group input-group-merge">
													<span className="input-group-text">
														<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-mail"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
													</span>
													<input type="text" id="email-id-icon" className="form-control" name="l_email" placeholder="Enter Email or Mobile Number" onChange={this.onInputChange} required />
												</div>
											</div>
											<div className="mb-1">
												<label className="form-label" htmlFor="password-icon">Password</label>
												<div className="input-group input-group-merge form-password-toggle">
													<span className="input-group-text">
														<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
													</span>
													<input type="password" id="password-icon" className="form-control" name="l_password" placeholder="Password" onChange={this.onInputChange} required />
												</div>
											</div>
											<div id="login_alert" className="error mb-2"></div>
											<button type="submit" className="btn btn-primary w-100 waves-effect waves-float waves-light btnslogin" disabled={this.state.loading}>
												{this.state.loading ? 'Logging in...' : 'Sign In'}
											</button>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

}

export default Login2;
